<template>
  <section id="reviews">
    <div class="container">
      <div class="px-4 py-5 text-center">
        <img src="https://www.rimborsoalvolo.it/cresources/outform/images/stelletestimonial.svg">
      </div>
      <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
        <div class="col px-4">
          <div class="">
            <div class="coverImgReview">
              <img class="" src="https://www.rimborsoalvolo.it/cresources/outform/images/review1.jpg" alt="">
            </div>
            <p class="titleReview">Alessandro Chines</p>
            <p class="txtReview"> "Rimborsoalvolo è un servizio eccellente. Il sito ti informa con estrema chiarezza sui
              casi in cui ti spetta un risarcimento. A quel punto seguendo la procedura online, anche questa
              semplicissima, è possibile ottenere il risarcimento in modo gratuito. Sono molto soddisfatto di essermi
              rivolto a loro."</p>
            <div class="linkReview">
              <a target="_blank" href="https://www.facebook.com/alessandro.chines1">
              <img src="">
              </a>
            </div>
          </div>
        </div>
        <div class="col px-4">
          <div class="">
            <div class="coverImgReview">
              <img class="" src="https://www.rimborsoalvolo.it/cresources/outform/images/review2.jpg" alt="">
            </div>
            <p class="titleReview">Giuliana Cimini</p>
            <p class="txtReview"> "Sono stati veramente professionali. Nelle
              giuste tempistiche ho ottenuto il rimborso per un over booking della Lufthansa. Molto soddisfatta del
              servizio. Grazie per tutta l assistenza e la cordialità. Consiglio
              vivamente."</p>
            <div class="linkReview">
              <a target="_blank" href="https://www.facebook.com/giulia.cimini.7">
              <img src="">
              </a>
            </div>
          </div>
        </div>
        <div class="col px-4">
          <div class="">
            <div class="coverImgReview">
              <img class="" src="https://www.rimborsoalvolo.it/cresources/outform/images/review3.jpg" alt="">
            </div>
            <p class="titleReview">Silvia Muia</p>
            <p class="txtReview"> "COMPLIMENTI A TUTTO IL TEAM DI RIMBORSOALVOLO PER LA GRANDE COLLABORAZIONE... HO
              OTTENUTO IL RIMBORSO DEL VOLO ANNULLATO NEL 2020!!!! Consiglio al 100%"</p>
            <div class="linkReview">
              <a target="_blank" href="https://www.facebook.com/silvia.muia">
              <img src="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RecensioniFB"
}
</script>

<style scoped>

</style>